module.exports = __webpack_public_path__ + "static/media/arrow.e8270e9a.svg";